import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { withRouter, Link } from 'react-router-dom';
import { path } from 'ramda';

import { routes } from '../../../../../routes';

import Card from '../../../../../components/Card';
import { getRegistrationMonthsExpired } from '../../../../../util/helpers';

const propTypes = {
  user: PropTypes.object,
  history: PropTypes.object,
};

const Registrations = ({ history, user }) => (
  <Card>
    <Card.Header>
      Registrations
      <Link
        to={routes.admin.users.profile.newRegistrationsBuilder(user.id)}
        className="btn btn-sm btn-primary float-right"
      >
        Add
      </Link>
    </Card.Header>
    <Card.Body>
      {user.registrations.length == 0 ? (
        <p>This user does not have any registrations</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Certification</th>
              <th>Status</th>
              <th>Step</th>
              <th>Enrolled On</th>
            </tr>
          </thead>
          <tbody>
            {user.registrations.map((registration) => (
              <tr
                className="clickableRow"
                key={registration.id}
                onClick={() => history.push(routes.admin.courseRegistrations.reviewBuilder(registration.id))}
              >
                <td>
                  {registration.trainingId
                    ? path(['training', 'name'], registration)
                    : path(['certification', 'name'], registration)}
                </td>
                <td>{getRegistrationMonthsExpired(registration) > 0 ? 'Expired' : registration.status}</td>
                <td>{registration.step}</td>
                <td>{registration.enrolledOn && moment(registration.enrolledOn).format('MM/DD/YYYY')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Card.Body>
  </Card>
);

Registrations.propTypes = propTypes;

export default withRouter(Registrations);
